import type { GetSKANAdPartnersResponseAction } from './getSKANAdPartners.action';
import type { FetchAvailableCampaignsForSANAdPartnersResponseAction } from './fetchAvailableCampaignsForSANAdPartners.action';
import type {
  UpdateAdPartnersForSKANAgencyPermissionsLoadingAction,
  UpdateAdPartnersForSKANAgencyPermissionsSuccessAction,
  UpdateAdPartnersForSKANAgencyPermissionsErrorAction,
} from './updateAdPartnersForSKANAgencyPermissions.action';

export * from './getSKANAdPartners.action';
export * from './fetchAvailableCampaignsForSANAdPartners.action';
export * from './updateAdPartnersForSKANAgencyPermissions.action';

export type SKAdNetworkAction =
  | GetSKANAdPartnersResponseAction
  | FetchAvailableCampaignsForSANAdPartnersResponseAction
  | UpdateAdPartnersForSKANAgencyPermissionsLoadingAction
  | UpdateAdPartnersForSKANAgencyPermissionsSuccessAction
  | UpdateAdPartnersForSKANAgencyPermissionsErrorAction;
